import * as THREE from "three";
import { patchArray, decorateArray } from "../../utils/data-utils";

import globalModels from "../global-models";
import seriesModels from "./models.json";

import globalEntities from "../global-entities";
import seriesEntities from "./entities.json";

import globalMaterials from "../global-materials";
import seriesMaterials from "./materials";

import globalTextures from "../global-textures";
import seriesTextures from "./textures.json";
import spots from "./spots";
import { createTimeAnimation, createToggleAnimation } from "../../utils/entity-utils";

let models = [];
let entities = [
  {
    id: "EnviroDome",
    object3D: "EnviroDome",
    parent: "scene",
    transform: {
      position: [1, -0.941218, 0],
      rotation: [-Math.PI/2, 0, Math.PI],
    },
  },

  createTimeAnimation("Valtra_T_Frontloader", "Frontloader_T_Action", "{context.tractor.state.loaderPosition}"),
  
  createTimeAnimation("Valtra_T_SteeringWheel", "SteeringWheel_Action", "{context.tractor.state.steeringAngle}"),
  createToggleAnimation("Valtra_T_SteeringWheel", "SteeringWheel_Tilt_Action", "{context.tractor.state.steeringwheel_tilt}",{ action: { timeScale: 1.1 }}),
  createToggleAnimation("Valtra_T_SteeringWheel", "Compartment_Action" , "{context.tractor.state.hatchOpen}"),
  //createToggleAnimation("Valtra_T_SteeringWheel", "Compartment_Premium_Action"  , "{context.tractor.state.hatchOpen}"),


  createTimeAnimation("Valtra_T_Steering", "Steering_Action", "{context.tractor.state.steeringAngle}"),
  
  createToggleAnimation("Valtra_T_DoorR", "DoorR_Action", "{context.tractor.state.doorOpen_R}"),
  createToggleAnimation("Valtra_T_DoorL", "DoorL_Action", "{context.tractor.state.doorOpen_L}"),
  
  
  createToggleAnimation("Valtra_T_Driver_Seat", "Seat_Arm_Rest_Right_Tilt", "{context.tractor.state.seatArmRestRightTilt}"),
  createToggleAnimation("Valtra_T_Driver_Seat", "Seat_Arm_Rest_Left_Tilt", "{context.tractor.state.seatArmRestLeftTilt}"),
  createToggleAnimation("Valtra_T_Driver_Seat", "Seat_Head_Rest_Tilt", "{context.tractor.state.seatHeadRestTilt}", { action: { timeScale: 0.3 }}),
  createToggleAnimation("Valtra_T_Driver_Seat", "Seat_Rotate", "{context.tractor.state.seatRotate}", { action: { timeScale: 0.3 }}),
  createToggleAnimation("Valtra_T_Driver_Seat", "TwinTrack_Tilt", "{context.tractor.state.twinTrackTilt}"),


  createToggleAnimation("Valtra_T_Toolbox", "Toolbox_Action", "{context.tractor.state.toolboxOpen}"),
  createToggleAnimation("Valtra_T_Seat", "Seat_Action_Front", "{context.tractor.state.seatDown}"),
  createToggleAnimation("Valtra_T_Seat", "Seat_Action_Backrest", "{context.tractor.state.backrest}"),
  createToggleAnimation("Valtra_T_Coolbox", "Coolbox_Action", "{context.tractor.state.coolboxOpen}"),
  createToggleAnimation("Valtra_T_Coolbox_Premium", "Coolbox_Premium_Action", "{context.tractor.state.coolboxOpen}"),
  createToggleAnimation("Valtra_T_SunScreen", "Sunscreen_Action_1", "{context.tractor.state.sunscreenDown}"),
  createToggleAnimation("Valtra_T_SunScreen2", "Sunscreen_Action", "{context.tractor.state.sunscreenDown}"), // Premium
  createToggleAnimation("Valtra_T_Trans", "Trans_Action", "{context.tractor.state.hitchUp}"),

  createToggleAnimation("Valtra_T_FrontLinkage", "FrontLinkageUp_Action", "{context.tractor.state.frontLinkageUp}"),
  createToggleAnimation("Valtra_T_FrontLinkage", "FrontLinkageWorkDrive_Action", "{context.tractor.state.frontLinkageWorkDrive}"),

  
  {
    id: "M219VV2550307_premium",
    object3D: "M219VV2550307_premium",
    visible: false,
  },
  ...spots,
];
let materials = [];
let textures = [];

models = patchArray(patchArray(globalModels, seriesModels), models);
entities = patchArray(patchArray(globalEntities, seriesEntities), entities);
materials = patchArray(globalMaterials, seriesMaterials, materials);
textures = patchArray(patchArray(globalTextures, seriesTextures), textures);

models = decorateArray(models, { preload: true });
textures = decorateArray(textures, {
  preload: true,
  encoding: THREE.sRGBEncoding,
});

const data = {
  entities,
  models,
  materials,
  textures,
};

process.env.NODE_ENV === "development" && console.log("t-series three", data);

export default data;
